import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div style={{ backgroundColor: "#F5F3F0" }}>

            <div className="privacy-policy-container">
                <div className="privacy-policy-content">
                    <p className="last-updated">Last updated: January 2026</p>

                    <h1>Privacy Policy (Datenschutzerklärung)</h1>

                    <section>
                        <h2>1. Introduction</h2>
                        <p>
                            Waraq Translations ("we", "our", "us") operates the website wa-raq.de.
                            We value your privacy and are committed to protecting your personal data
                            in compliance with the General Data Protection Regulation (GDPR) and
                            German data protection laws.
                        </p>
                        <p>
                            This Privacy Policy explains how we handle personal data when you visit
                            our website, contact us, or use our services.
                        </p>
                    </section>

                    <section>
                        <h2>2. Data Controller</h2>
                        <p><strong>Waraq Translations</strong></p>
                        <p>Owner: Hazar El-Kadri</p>
                        <p>Chopinstraße 32</p>
                        <p>40593 Düsseldorf, Germany</p>
                        <p>Email: <a href="mailto:translate@wa-raq.de">translate@wa-raq.de</a></p>
                        <p>Phone: <a href="tel:+491712120690">+49 151 74578596</a></p>
                    </section>

                    <section>
                        <h2>3. Data We Collect</h2>
                        <p>
                            Currently, this website does not collect, process, or store personal
                            data automatically.
                        </p>
                        <ul>
                            <li>No contact forms, analytics tools, or cookies are active at this time.</li>
                            <li>Access to our internal dashboard is provided individually and privately to authorized translators and clients only.</li>
                        </ul>
                        <p>
                            If we introduce features that involve personal data collection (e.g.,
                            forms or analytics), we will update this Privacy Policy accordingly.
                        </p>
                    </section>

                    <section>
                        <h2>4. Legal Basis for Processing</h2>
                        <p>
                            If personal data is processed in the future, it will be done in
                            accordance with the following GDPR provisions:
                        </p>
                        <ul>
                            <li><strong>Article 6(1)(b)</strong> — performance of a contract or pre-contractual obligations</li>
                            <li><strong>Article 6(1)(f)</strong> — legitimate interests, such as website security and communication</li>
                            <li><strong>Article 6(1)(a)</strong> — consent, if explicitly given by users</li>
                        </ul>
                    </section>

                    <section>
                        <h2>5. Data Security</h2>
                        <p>
                            We use appropriate technical and organizational measures to ensure the
                            security of your data and prevent unauthorized access or misuse.
                        </p>
                        <p>
                            Access to private dashboards is restricted to verified clients and
                            translators using secure login credentials.
                        </p>
                    </section>

                    <section>
                        <h2>6. Data Sharing</h2>
                        <p>
                            We do not share personal data with third parties unless legally required
                            or explicitly agreed upon with the client.
                        </p>
                        <p>We currently use no analytics, cookies, or third-party services.</p>
                    </section>

                    <section>
                        <h2>7. Data Retention</h2>
                        <p>
                            We keep personal data only as long as necessary to fulfill contractual
                            or legal obligations or maintain an active business relationship.
                        </p>
                    </section>

                    <section>
                        <h2>8. Your Rights under GDPR</h2>
                        <p>You have the right to:</p>
                        <ul>
                            <li>Access your data (Art. 15 GDPR)</li>
                            <li>Correct inaccurate data (Art. 16 GDPR)</li>
                            <li>Request deletion of your data (Art. 17 GDPR)</li>
                            <li>Restrict processing (Art. 18 GDPR)</li>
                            <li>Data portability (Art. 20 GDPR)</li>
                            <li>Object to processing (Art. 21 GDPR)</li>
                        </ul>
                        <p>
                            To exercise any of these rights, please contact{' '}
                            <a href="mailto:translate@wa-raq.de">translate@wa-raq.de</a>.
                        </p>
                    </section>

                    <section>
                        <h2>9. Hosting and Server Logs</h2>
                        <p>
                            Our hosting provider automatically collects log files (e.g., IP address,
                            browser type, time of access) to maintain technical security.
                        </p>
                        <p>
                            These logs are temporary, anonymized, and not used to identify individuals.
                        </p>
                    </section>

                    <section>
                        <h2>10. External Links</h2>
                        <p>
                            Our website may contain links to external sites. We are not responsible
                            for their content or privacy practices.
                        </p>
                    </section>

                    <section>
                        <h2>11. Updates</h2>
                        <p>
                            We may update this Privacy Policy to reflect legal or technical changes.
                            The latest version will always be published on this page.
                        </p>
                    </section>

                    <section className="contact-section">
                        <h2>Contact for Data Protection:</h2>
                        <p>Hazar El-Kadri</p>
                        <p><a href="mailto:translate@wa-raq.de">translate@wa-raq.de</a></p>
                    </section>
                </div>
            </div>
        </div>

    );
};

export default PrivacyPolicy;